import { useNavigate } from "react-router";

import { PageHeader } from "@/components/shared/page-header";
import { SearchableSelect } from "@/components/shared/searchable-select";
import { Skeleton } from "@/components/ui/skeleton";

import { CurrentWorkspaceProfileCard } from "./current-workspace-profile-card";
import { useCurrentWorkspace } from "./use-current-workspace";

export function CurrentWorkspaceSettingsPage() {
  const navigate = useNavigate();
  const {
    activeWorkspace,
    isLoading,
    bonusRules,
    canUpdate,
    canSwitchWorkspace,
    workspaces,
    selectedWorkspaceId,
    setSelectedWorkspaceId,
    form,
    isEditDialogOpen,
    openEdit,
    closeEdit,
    isUpdating,
    onSubmit,
  } = useCurrentWorkspace();

  if (isLoading) {
    return (
      <div className="space-y-6">
        <PageHeader
          title="Pengaturan Toko Ini"
          description="Memuat data profil workspace..."
        />
        <Skeleton className="h-64 w-full rounded-xl" />
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {canSwitchWorkspace && (
        <div className="w-64">
          <SearchableSelect
            value={selectedWorkspaceId}
            onChange={setSelectedWorkspaceId}
            options={workspaces.map((w) => ({ value: w.id, label: w.name }))}
            placeholder="Pilih Workspace..."
          />
        </div>
      )}

      <PageHeader
        title="Pengaturan Toko Ini"
        description={`Konfigurasi spesifik untuk outlet ${activeWorkspace?.name ?? ""}`}
      />

      <CurrentWorkspaceProfileCard
        workspace={activeWorkspace}
        canUpdate={Boolean(canUpdate)}
        bonusRules={bonusRules}
        form={form}
        isEditDialogOpen={isEditDialogOpen}
        onOpenEdit={openEdit}
        onCloseEdit={closeEdit}
        onSubmit={onSubmit}
        isUpdating={isUpdating}
        onNavigateToBonusRules={() =>
          canSwitchWorkspace && activeWorkspace
            ? navigate(
                `/settings/workspaces/${activeWorkspace.id}/gaji-bonus-rider`,
              )
            : navigate("/settings/workspace/gaji-bonus-rider")
        }
        onNavigateToNumberSequence={() =>
          canSwitchWorkspace && activeWorkspace
            ? navigate(
                `/settings/workspaces/${activeWorkspace.id}/number-sequence`,
              )
            : navigate("/settings/workspace/number-sequence")
        }
      />
    </div>
  );
}
